<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Centerpiece } from '#library/components.schema.build.ts'
	import Render from '#components/render.svelte'

	interface Props {
		blok: Blok<Centerpiece>
	}

	let { blok }: Props = $props()
</script>

<section class="centerpiece {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		<div class="title">{blok.title}</div>
		{#if blok.body}
			<div class="body">
				<Render content={blok.body} />
			</div>
		{/if}
	</div>
</section>

<style lang="css">
	.centerpiece {
		background-color: var(--c-background);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
		text-align: center;
	}

	.title {
		color: var(--c-foreground);
		font: 600 var(--f-h2);
		letter-spacing: var(--ls-h2);
		margin-inline: auto;
		max-width: 20ch;
		text-wrap: balance;
	}

	.body {
		color: var(--c-midground);
		font: var(--f-body1);
		margin: 1.25rem auto 0;
		max-width: 60ch;
		text-wrap: balance;

		:global {
			.link {
				--c-foreground: var(--c-midground);
			}
		}
	}
</style>
